export default __webpack_public_path__ + "static/media/logo.94e87d48.png";